import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faChartLine,
  faTools,
  faShieldHalved,
  faMapLocationDot,
} from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-home-section-feature',
  standalone: true,
  imports: [FontAwesomeModule, TranslateModule],
  templateUrl: './home-section-feature.component.html',
  styleUrls: ['./home-section-feature.component.scss'],
})
export class HomeSectionFeatureComponent {
  public items = [
    {
      icon: faChartLine,
      titleKey: 'home.feature.items.statistics',
    },
    {
      icon: faTools,
      titleKey: 'home.feature.items.tools',
    },
    {
      icon: faShieldHalved,
      titleKey: 'home.feature.items.security',
    },
    {
      icon: faMapLocationDot,
      titleKey: 'home.feature.items.locations',
    },
  ];
}
